
import { computed, defineComponent, PropType, toRefs } from 'vue'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import CFileDownload from './CFileDownload.vue'

export default defineComponent({
  name: 'CAssociatedParticipants',
  components: { CFileDownload },
  props: {
    participants: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  setup(props) {
    const i18n = useI18nForVue2()

    const { participants } = toRefs(props)

    return {
      fileContent: computed(() => `seller_id\r\n${participants.value.join('\r\n')}`),
      placeholder: computed(
        () => `${participants.value.length} ${i18n.t('ctx.discount.detail.associated-structures')}`,
      ),
    }
  },
})
